var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVectorRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 770,
    viewBox: "0 0 177 770",
    width: 177,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m618.098 53.6591c97.295 78.7879 112.298 221.5329 33.51 318.8279-78.789 97.296-182.804 202.504-247.795 306.002-64.992 103.497-231.105 124.056-318.8286 33.51-87.72353-90.546-121.3724-210.328-33.5103-318.828 87.8619-108.501 161.4599-199.386 247.7949-306.0017 86.336-106.6155 221.533-112.2987 318.829-33.5102z",
    fill: "#cbe4ce",
    opacity: 0.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgVectorRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/vectorRight.ee9282139dc42d5efd7daa62cafd2ce6.svg";